<script setup lang="ts">
import AppSvgIconInner from './AppSvgIconInner.vue';
import type {
  AppSvgIconColor,
  AppSvgIconTranslate,
  AppSvgIconRotate,
  AppSvgIconSize,
  AppSvgIconType,
} from './AppSvgIcon.model';

export interface AppSvgIconProps {
  name: AppSvgIconType;
  translate?: AppSvgIconTranslate;
  rotate?: AppSvgIconRotate;
  size?: AppSvgIconSize;
  color?: AppSvgIconColor;
  ariaLabel?: string;
}

const props = defineProps<AppSvgIconProps>();
</script>

<template>
  <div>
    <AppSvgIconInner
      :name="props.name"
      :translate="props.translate"
      :rotate="props.rotate"
      :size="props.size"
      :color="props.color"
      :aria-label="props.ariaLabel"
    />
  </div>
</template>
